import { Box, Flex } from '@chakra-ui/react';
import { useColorModeValue } from '@chakra-ui/system';
import { useEffect, useRef, useState } from 'react'
import { useData } from 'services/data/DataProvider';
import { db } from 'services/db';
import { updateStratsAndMistakes } from 'services/dbservice';
import MistakeChart from 'views/trader/strategies/charts/MistakeChart';
import StrategiesChart from 'views/trader/strategies/charts/StrategiesChart';
import StrategyTradesModal from 'views/trader/strategies/components/StrategyTradesModal';
import { Trade, TradeStrategy } from 'views/trader/trades/variables/types';

const StrategiesPanel = () => {

  interface smdata { id: number, name: string, trades: Trade[], nett: number }
  const { usertrades, strategies, mistakes, defaultcurrency } = useData();

  // Chakra Color Mode
  //const paleGray = useColorModeValue('#DFE6F6', 'whiteAlpha.100');

  const tradesModalRef = useRef(null);
  const [stratData, setStratData] = useState<smdata[]>([]);
  const [mistData, setMistData] = useState<smdata[]>([]);
  const [modaltrades, setmodaltrades] = useState<{ id: number, name: string, trades: Trade[], nett: number }>({ id: 0, name: '', trades: [], nett: 0 });

  const placeholderfunc = (s: any) => { }

  useEffect(() => {
    let sdata: smdata[] = [];
    for (let s of strategies) {
      sdata.push({ id: s.id, name: s.name, trades: [], nett: 0 });
    }

    let mdata: smdata[] = [];
    for (let m of mistakes) {
      mdata.push({ id: m.id, name: m.name, trades: [], nett: 0 });
    }

    updateStrategyData(usertrades, sdata);
    updateMistakeData(usertrades, mdata);

  }, [strategies, mistakes, usertrades])


  const updateStrategyData = (trades: Trade[], stratdata: smdata[]) => {

    for (let tr of trades) {

      let ex = (tr.currency !== defaultcurrency ? tr.exchange : 1);

      tr.strategies.forEach((s: TradeStrategy) => {
        let i = stratdata.findIndex((strat) => strat.id === s.id)
        if (i > -1) {
          let tri = stratdata[i].trades.findIndex((t) => t.tradeid === tr.tradeid);
          if (tri < 0) {
            stratdata[i].trades.push(tr);
            stratdata[i].nett += (tr.nett / ex);
          }
        }
        else {
          stratdata.push({ id: s.id, name: s.name, trades: [tr], nett: (tr.nett / ex) })
        }
      })
    }
    setStratData(stratdata);
  }

  const updateMistakeData = async (trades: Trade[], mistdata: smdata[]) => {


    for (let tr of trades) {
      let ex = (tr.currency !== defaultcurrency ? tr.exchange : 1);

      for (let m of tr.mistakes) {

        let nett = 0;

        if (tr.profitloss < 0) {
          nett += (tr.nett / ex);
        }
        else {

          if (tr.target_price > 0) {

            let diff = Math.abs((tr.target_price - tr.exit_avg));

            await db.instruments.where({ ticker: tr.ticker }).toArray().then((ins) => {
              if (ins.length) {
                if (tr.side.toLowerCase() === 'sell') {
                  if (tr.target_price < tr.exit_avg) {
                    nett -= (diff * tr.size * ins[0].pointvalue) / ex;
                  }
                }
                else {
                  if (tr.target_price > tr.exit_avg) {
                    nett -= (diff * tr.size * ins[0].pointvalue) / ex;
                  }
                }
              }
            }).catch(() => { })
          }
        }

        let mindex = mistdata.findIndex((mi) => mi.id === m.id);

        if (mindex > -1) {
          let trindex = mistdata[mindex].trades.findIndex((t) => t.tradeid === tr.tradeid);
          if (trindex < 0) {
            mistdata[mindex].trades.push(tr);
            mistdata[mindex].nett += nett;
          }
        }
        else {
          mistdata.push({ id: m.id, name: m.name, trades: [tr], nett: nett })
        }
      }
    }

    setMistData(mistdata);
  }

  /*const updatemistake = async (m: { name: string, id: number }) => {
    await updateStratsAndMistakes([], [m]);
  }*/
  const showtrades = (type: string, index: number) => {
    switch (type) {
      case 'strategy':
        setmodaltrades(stratData[index]);
        tradesModalRef.current.openModal(type, stratData[index]);
        break;
      case 'mistake':
        setmodaltrades(mistData[index]);
        tradesModalRef.current.openModal(type, mistData[index]);
        break;
    }
  }

  return (
    <>
      <Box h='100%' >
        <Flex direction={{ base: 'column' }} gap={6} h='100%' justify={'space-evenly'}>
          <Flex h='50%'><StrategiesChart strats={stratData} currency={defaultcurrency} showtrades={showtrades} /></Flex>
          <Flex h='50%'> <MistakeChart mistakes={mistData} currency={defaultcurrency} showtrades={showtrades} /></Flex>
        </Flex>
      </Box>

      <StrategyTradesModal ref={tradesModalRef} data={modaltrades} onclosemodal={placeholderfunc} />

    </>
  )
}

export default StrategiesPanel